var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topbar'), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('sortHeader'), _vm._v(" "), _c('heardernav', {
    ref: "navComp",
    attrs: {
      "activeLi": _vm.activeLi,
      "firstCatShow": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "shop-focus-img"
  }, [_c('mt-swipe', {
    staticStyle: {
      "height": "405px",
      "cursor": "pointer"
    },
    attrs: {
      "auto": 3000,
      "speed": 1000
    }
  }, _vm._l((_vm.sliderItems), function(i, index) {
    return _c('mt-swipe-item', {
      key: index,
      style: ({
        background: 'url(' + i.mediaCode + ')' + 'no-repeat center top'
      }),
      attrs: {
        "onclick": "jumpUrl(this)"
      }
    }, [_c('a', {
      staticStyle: {
        "display": "none"
      }
    }, [_vm._v(_vm._s(i.link))])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "recommend",
    staticStyle: {
      "border": "solid 1px #ddd",
      "margin-bottom": "20px"
    }
  }, [_c('div', {
    staticClass: "hd1"
  }, [_c('h3', {
    staticClass: "hd-tit1"
  }, [_vm._v("热门推荐")]), _vm._v(" "), (_vm.cabinetId != null && _vm.cabinetId != '' && _vm.hotGoodsList != null && _vm.hotGoodsList.length > 0) ? _c('a', {
    staticClass: "more",
    on: {
      "click": function($event) {
        _vm.jumpToCabinet()
      }
    }
  }, [_vm._v("更多 >")]) : _vm._e()]), _vm._v(" "), _c('mt-swipe', {
    staticStyle: {
      "height": "280px"
    },
    attrs: {
      "show-indicators": false
    }
  }, [_c('mt-swipe-item', [_c('div', {
    staticClass: "bd",
    staticStyle: {
      "line-height": "0px"
    }
  }, [_c('ul', {
    staticClass: "items li5"
  }, _vm._l((_vm.hotGoodsList), function(hotGood) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.goDetail(hotGood.goodsCode)
        }
      }
    }, [_c('a', [_c('img', {
      attrs: {
        "src": _vm.imgPath + hotGood.imgMiddle,
        "width": "210",
        "height": "210"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "line-tit"
    }, [_c('a', {
      staticClass: "co4"
    }, [_vm._v(_vm._s(hotGood.goodsName))])]), _vm._v(" "), (hotGood.goodsPrice == 0) ? _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v(_vm._s(hotGood.unitPrice == 0 ? "" : "￥" + (hotGood.unitPrice / 100).toFixed(2)))])]) : _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v("\n\t\t\t\t                    \t" + _vm._s(hotGood.goodsPrice) + "\n\t\t\t\t\t\t\t\t\t\t"), (hotGood.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (hotGood.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (hotGood.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (hotGood.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])])])
  }))])]), _vm._v(" "), (_vm.secondPageShow) ? _c('mt-swipe-item', [_c('div', {
    staticClass: "bd",
    staticStyle: {
      "line-height": "0px"
    }
  }, [_c('ul', {
    staticClass: "items"
  }, _vm._l((_vm.hotSecondList), function(hotGood) {
    return _c('li', {
      on: {
        "click": function($event) {
          _vm.goDetail(hotGood.goodsCode)
        }
      }
    }, [_c('a', [_c('img', {
      attrs: {
        "src": _vm.imgPath + hotGood.imgMiddle,
        "width": "210",
        "height": "210"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "line-tit"
    }, [_c('a', {
      staticClass: "co4"
    }, [_vm._v(_vm._s(hotGood.goodsName))])]), _vm._v(" "), (hotGood.goodsPrice == 0) ? _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v(_vm._s(hotGood.unitPrice == 0 ? "" : "￥" + (hotGood.unitPrice / 100).toFixed(2)))])]) : _c('div', {
      staticClass: "line-price"
    }, [_c('span', {
      staticClass: "co2"
    }, [_vm._v("\n\t\t\t                \t\t\t" + _vm._s(hotGood.goodsPrice) + "\n\t\t\t\t\t\t\t\t\t\t"), (hotGood.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (hotGood.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (hotGood.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (hotGood.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e()])])])
  }))])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.secKillBo != null && _vm.secKillBo != ''),
      expression: "secKillBo!=null&&secKillBo!=''"
    }]
  }, [_c('div', {
    staticClass: "recommend",
    staticStyle: {
      "margin-bottom": "20px",
      "height": "350px"
    }
  }, [_c('a', {
    staticClass: "more1",
    on: {
      "click": function($event) {
        _vm.jumpTo('seckillList')
      }
    }
  }, [_vm._v("更多 >")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "buying"
  }, [_c('ul', [_c('li', {
    staticClass: "shopTime"
  }, [_c('h1', {
    staticStyle: {
      "width": "231px"
    }
  }, [_vm._v("抢购")]), _vm._v(" "), _c('h2', {
    staticClass: "eg"
  }, [_vm._v("FLASH DEALS")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "64px",
      "height": "64px"
    },
    attrs: {
      "src": require("../.././../static/images/lightning.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "18px",
      "margin-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.activityName))]), _vm._v(" "), _c('div', {
    staticClass: "clock",
    staticStyle: {
      "margin": "2em"
    }
  })]), _vm._v(" "), _vm._l((_vm.seckillGoods), function(list, index) {
    return (index < 4) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.goDetail(list.goodsCode)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.imgPath + (list.imgMiddle != null ? (list.imgMiddle.split(';'))[0] : '')
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(list.goodsName))]), _vm._v(" "), _c('div', {
      staticClass: "priceBox"
    }, [_c('span', {
      staticClass: "currentPrice"
    }, [_vm._v("￥" + _vm._s(list.seckillPrice / 100))]), _vm._v(" "), _c('span', {
      staticClass: "originalPrice"
    }, [_vm._v(_vm._s(list.unitPrice == 0 ? "" : "￥" + list.unitPrice / 100))])])])]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "clear mt15"
  }), _vm._v(" "), _vm._l((_vm.firstCatList), function(cat, index) {
    return _c('div', [(cat.catCode == 'spike' && cat.goodsList.length > 0) ? _c('div', {
      staticClass: "grid-c1 miaosha"
    }, [_c('div', {
      staticClass: "side-l"
    }, [_c('div', {
      staticClass: "hd"
    }, [_c('a', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多 >")]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, _vm._l((cat.catBoList), function(childCat, idx) {
      return (idx < 8) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])]) : _vm._e()
    })), _vm._v(" "), _c('h3', [_c('i', {
      staticClass: "ico-3"
    }), _vm._v(_vm._s(cat.catNameCn) + "专区")])]), _vm._v(" "), _c('div', {
      staticClass: "bd"
    }, [_c('ul', {
      staticClass: "items"
    }, _vm._l((cat.goodsList), function(goodsBo) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + goodsBo.imgMiddle,
          "width": "197",
          "height": "197"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "line-tit"
      }, [_c('a', {
        staticClass: "co4",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v(_vm._s(goodsBo.unitPrice == 0 ? "" : "￥" + (goodsBo.unitPrice / 100).toFixed(2)))]), _c('span', {
        staticClass: "old"
      }, [_vm._v("￥" + _vm._s((goodsBo.marketPrice / 100).toFixed(2)))])]), _vm._v(" "), _c('div', {
        staticClass: "pinpainow_item_time"
      }, [(goodsBo.saleStatus === 'end') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("\n                \t\t\t\t已结束\n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'wait_start') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("\n                \t\t\t\t距开始 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒\n                \t\t\t")]) : _vm._e(), _vm._v(" "), (goodsBo.saleStatus === 'on_sale') ? _c('span', {
        staticClass: "brandsknow_time_txt"
      }, [_vm._v("\n                \t\t\t\t距结束 "), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.hour))]), _vm._v("时"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.minute))]), _vm._v("分"), _c('i', {
        staticClass: "brandsknow_time_txt_time"
      }, [_vm._v(_vm._s(goodsBo.second))]), _vm._v("秒\n                \t\t\t")]) : _vm._e()])])
    }))])])]) : _vm._e(), _vm._v(" "), (cat.catCode != 'spike' && cat.goodsList.length > 0) ? _c('div', {
      staticClass: "grid-c1 suit-dress"
    }, [_c('div', {
      staticClass: "side-l"
    }, [_c('div', {
      staticClass: "hd"
    }, [_c('a', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_vm._v("更多 >")]), _vm._v(" "), _c('ul', {
      staticClass: "tags"
    }, _vm._l((cat.catBoList), function(childCat, idx) {
      return (idx < 8) ? _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.getCatGoods(childCat.catCode, childCat.catNameCn)
          }
        }
      }, [_vm._v(_vm._s(childCat.catNameCn))])]) : _vm._e()
    })), _vm._v(" "), _c('h3', [_vm._v(_vm._s(cat.catNameCn) + "专区")])]), _vm._v(" "), _c('div', {
      staticClass: "bd"
    }, [_c('a', {
      staticClass: "showpic",
      on: {
        "click": function($event) {
          _vm.getMore(cat.catCode, cat.catNameCn)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": cat.picPath,
        "width": "300",
        "height": "550"
      }
    })]), _vm._v(" "), _c('ul', {
      staticClass: "items"
    }, _vm._l((cat.goodsList), function(goodsBo) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.goDetail(goodsBo.goodsCode)
          }
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.profixPath + goodsBo.imgMiddle,
          "width": "197",
          "height": "197"
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "line-tit"
      }, [_c('a', {
        staticClass: "co4",
        attrs: {
          "href": "#"
        }
      }, [_vm._v(_vm._s(goodsBo.goodsName))])]), _vm._v(" "), (goodsBo.goodsPrice == 0) ? _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v(_vm._s(goodsBo.unitPrice == 0 ? "" : "￥" + (goodsBo.unitPrice / 100).toFixed(2)) + " ")])]) : _c('div', {
        staticClass: "line-price"
      }, [_c('span', {
        staticClass: "co3"
      }, [_vm._v("\n                        \t\t" + _vm._s(goodsBo.goodsPrice) + "\n\t\t\t\t\t\t\t\t"), (goodsBo.pointType == 'point') ? _c('span', [_vm._v("积分")]) : (goodsBo.pointType == 'special') ? _c('span', [_vm._v("专用积分")]) : (goodsBo.pointType == 'red') ? _c('span', [_vm._v("红积分")]) : (goodsBo.pointType == 'blue') ? _c('span', [_vm._v("蓝积分")]) : _vm._e(), _vm._v(" \n                        \t")])])])
    }))])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "clear mt15"
    }), _vm._v(" "), _vm._l((_vm.adsItem), function(ads, ads_idx) {
      return (index == ads_idx) ? _c('div', {
        staticStyle: {
          "margin-top": "15px"
        }
      }, [_c('a', {
        attrs: {
          "href": ads.link
        }
      }, [_c('img', {
        attrs: {
          "src": ads.mediaCode,
          "width": "1200",
          "height": "130"
        }
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "clear mt15"
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "top",
    on: {
      "click": function($event) {
        _vm.scrollToTop()
      }
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "clear mt20"
  })], 2), _vm._v(" "), (_vm.bottomAdsItem.mediaCode != null) ? _c('div', {
    staticStyle: {
      "padding-bottom": "0.8rem",
      "width": "1200px",
      "margin": "auto"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.bottomAdsItem.mediaCode,
      "width": "1200",
      "height": "60"
    }
  })]) : _vm._e(), _vm._v(" "), _c('footermenu'), _vm._v(" "), _c('footercopyright')], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hd"
  }, [_c('h3', {
    staticClass: "hd-tit"
  }, [_vm._v("抢购")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', [_vm._v("TOP")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71629636","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/index.vue
// module id = nFGY
// module chunks = 1